import { countryConstants } from "../../constants";
import { countryService } from "../../services";
import { alertActions } from "../alert.actions";

export const countryActions = {
  getSingleParameter,
  getAllParameters,
  addParameter,
  updateParameter,
  deleteParameter,
  clear,
};

// get single parameter
function getSingleParameter() {}

// get all parameter
function getAllParameters() {
  return (dispatch) => {
    dispatch(request());

    countryService.getAllParameters().then(
      (items) => dispatch(success(items)),
      (error) => dispatch(failure(error))
    );
  };

  function request(params) {
    return { type: countryConstants.GET_ALL_REQUEST, params };
  }
  function success(items) {
    return { type: countryConstants.GET_ALL_SUCCESS, items };
  }
  function failure(error) {
    return { type: countryConstants.GET_ALL_FAILURE, error };
  }
}

// add parameter
function addParameter(name, code) {
  return (dispatch) => {
    dispatch(request(name, code));

    countryService.addParameter(name, code).then(
      (parameter) => {
        dispatch(success(parameter));
        dispatch(alertActions.success(parameter));
      },
      (error) => {
        dispatch(failure(error));
        dispatch(alertActions.error(error));
      }
    );
  };

  function request(parameter) {
    return { type: countryConstants.ADD_REQUEST, parameter };
  }
  function success(parameter) {
    return { type: countryConstants.ADD_SUCCESS, parameter };
  }
  function failure(error) {
    return { type: countryConstants.ADD_FAILURE, error };
  }
}

// update parameter
function updateParameter(id, name, code) {
  return (dispatch) => {
    dispatch(request(id, name, code));

    countryService.updateParameter(id, name, code).then(
      (parameter) => {
        dispatch(success(parameter));
        dispatch(alertActions.success(parameter));
      },
      (error) => {
        dispatch(failure(error));
        dispatch(alertActions.error(error));
      }
    );
  };

  function request(parameter) {
    return { type: countryConstants.UPDATE_REQUEST, parameter };
  }
  function success(parameter) {
    return { type: countryConstants.UPDATE_SUCCESS, parameter };
  }
  function failure(error) {
    return { type: countryConstants.UPDATE_FAILURE, error };
  }
}

// delete parameter
function deleteParameter(id) {
  return (dispatch) => {
    dispatch(request(id));

    countryService.deleteParameter(id).then(
      (parameter) => {
        dispatch(success(parameter));
        dispatch(alertActions.success(parameter));
      },
      (error) => {
        dispatch(failure(error));
        dispatch(alertActions.error(error));
      }
    );
  };

  function request(parameter) {
    return { type: countryConstants.DELETE_REQUEST, parameter };
  }
  function success(parameter) {
    return { type: countryConstants.DELETE_SUCCESS, parameter };
  }
  function failure(error) {
    return { type: countryConstants.DELETE_FAILURE, error };
  }
}

// clear parameter
function clear() {
  return { type: countryConstants.CLEAR };
}
